module.exports = __webpack_public_path__ + "img/4.5ab8a982.jpg";